export default {
  fetchInitialPending: false,
  fetchListPending: false,
  bankAccounts: [],
  fetchGroupedListPending: false,
  bankAccountsByGroup: [],
};
